<template>

    <div class="card m-1 bg-light mx-auto" style="width: 90%;">
        <a href="#/" class="btn btn-info" style="width: 20%;">Terug</a>
        <img :src="require('../assets/'+artikel.img)" class="card-img-top m-3 mx-auto imgratio" alt="...">
        <div class="card-body text-left">
            <h5 class="card-title">{{artikel.titel}}</h5>
            <h6 class="card-subtitle text-secondary">Publicatiedatum: {{artikel.tijd}}</h6>
            <div class="card-body">
                <p v-for="regel in artikel.tekst" v-bind:key="regel">{{regel}}</p>
            </div>
            <div v-if="toonEindtekst" class="text-muted card-footer border-top-0">{{artikel.eindtekst}} <span v-html="getUrl()"></span></div>

        </div>
        <a href="#/" class="btn btn-info" style="width: 20%;">Terug</a>
    </div>
</template>
<script>
    import artikels from '@/assets/artikelen.json';

    export default {
        name: 'Artikel',
        data() {
            return {
                artikel: undefined,
            }
        },
        created() {
            this.artikel = artikels[parseInt(this.$route.params.id)];
        },
        methods: {
            getUrl(){
                if (this.artikel.eindteksturl !== undefined){
                    return '<a href=' +this.artikel.eindteksturl +'>'+this.artikel.eindteksturl+'</a>'
                }
                return '';
            },
        },
        computed:{
            toonEindtekst(){
                return (this.artikel.eindtekst !== undefined) && (this.artikel.eindtekst.length >0);
            }
        }
    }
</script>
<style scoped>
    .imgratio{
        max-width:400px;
        max-height:400px;
        width: auto;
        height: auto;
    }
    h6{
        font-size: .6em;
    }
</style>